const SESSION_KEY =
  process.env.REACT_APP_SESSION_KEY || 'cliqloan-user-app-session';
const USER_SESSION_KEY =
  process.env.REACT_APP_USER_SESSION_KEY || 'cliqloan-user-user-session';
const HANDOFF_MAX_AGE_MS = 60 * 1000;

/** Resolve CliQLoan app URLs from hostname when build-time env is missing or wrong (AS_D7). */
export function resolveCliqloanAppUrls() {
  const host = (window.location.hostname || '').toLowerCase();
  if (host.includes('stage-support') || host.includes('stage.cliqloan')) {
    return {
      signInUrl: 'https://stage.cliqloan.com/signin',
      dashboardUrl: 'https://stage.cliqloan.com/',
    };
  }
  if (host === 'support.cliqloan.com' || host.endsWith('.support.cliqloan.com')) {
    return {
      signInUrl: 'https://app.cliqloan.com/signin',
      dashboardUrl: 'https://app.cliqloan.com/',
    };
  }
  return {
    signInUrl:
      process.env.REACT_APP_SIGN_IN_URL || 'https://dev.kramasoft.com/signin',
    dashboardUrl:
      process.env.REACT_APP_DASHBOARD_URL || 'https://dev.kramasoft.com/',
  };
}

export function getSessionStorageKeys() {
  return { SESSION_KEY, USER_SESSION_KEY };
}

/** Valid CliQLoan app session JSON (same shape as Ks_CLIQLOAN_FRONTEND auth.js). */
export function parseAppSession(raw) {
  if (!raw || typeof raw !== 'string') return null;
  try {
    const parsed = JSON.parse(raw);
    if (parsed?.access_token || parsed?.data?.userCode || parsed?.data?.email) {
      return parsed;
    }
  } catch {
    // Old support stub values (e.g. plain "ravish2023") are not valid app sessions.
  }
  return null;
}

export function isCliqloanLoggedIn() {
  const userFlag = localStorage.getItem(USER_SESSION_KEY);
  if (userFlag === 'signout' || userFlag !== 'login') {
    return false;
  }
  return !!parseAppSession(localStorage.getItem(SESSION_KEY));
}

/** Cross-origin handoff from CliQLoan app (#cliqloan_auth=… in URL hash). */
export function consumeSessionHandoffFromHash() {
  const hash = window.location.hash || '';
  const prefix = '#cliqloan_auth=';
  if (!hash.startsWith(prefix)) return false;

  const stripHash = () => {
    window.history.replaceState(
      null,
      '',
      window.location.pathname + window.location.search
    );
  };

  try {
    const payload = JSON.parse(
      atob(decodeURIComponent(hash.slice(prefix.length)))
    );
    if (!payload?.s || payload.u !== 'login') throw new Error('invalid');
    if (Date.now() - (payload.t || 0) > HANDOFF_MAX_AGE_MS) {
      throw new Error('expired');
    }
    if (!parseAppSession(payload.s)) throw new Error('invalid session');

    localStorage.setItem(SESSION_KEY, payload.s);
    localStorage.setItem(USER_SESSION_KEY, payload.u);
    stripHash();
    return true;
  } catch {
    stripHash();
    return false;
  }
}

export function clearCliqloanSession() {
  localStorage.removeItem(SESSION_KEY);
  localStorage.setItem(USER_SESSION_KEY, 'signout');
}

export function redirectToSignIn() {
  window.location.replace(resolveCliqloanAppUrls().signInUrl);
}

export function getCliqloanDashboardUrl() {
  return resolveCliqloanAppUrls().dashboardUrl;
}
